export default class CategoriesView {
    constructor(element) {
        this.browsePane = element.querySelector('[data-browse-pane]');
        this.resultsPane = element.querySelector('[data-search-results-pane]');
        this.searchField = element.querySelector('[data-search-field]');
        this.clearSearchButton = element.querySelector('[data-clear-search-button]');

        this.showBrowse();
        this.searchField.addEventListener('keyup', this.updateVisiblePane.bind(this));
        this.clearSearchButton.addEventListener('click', this.clearSearchBox.bind(this));
    }

    updateVisiblePane(event) {
        const isUserSearching = event.currentTarget.value.length > 0;

        this.hideElement(this.resultsPane);
        this.hideElement(this.browsePane);

        if (isUserSearching) {
            this.showElement(this.resultsPane);
            this.showElement(this.clearSearchButton);
        } else {
            this.showBrowse();
        }
    }

    hideElement(element) {
        element.setAttribute('data-hidden', true);
    }

    showBrowse() {
        this.showElement(this.browsePane);
        this.hideElement(this.clearSearchButton);
    }

    showElement(element) {
        element.removeAttribute('data-hidden');
    }

    clearSearchBox() {
        this.searchField.value = '';
        this.showBrowse();
        this.hideElement(this.resultsPane);
    }
}
